var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ua-pdt-gift"},[(_vm.activityData.activityDesc)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.activityData.activityDesc)}}):_vm._e(),_vm._v(" "),_c('p',{staticClass:"ua-pdt-gift-tips"},[_vm._v("* 具体赠品样式以实际收到赠品为准")])])}
var staticRenderFns = []

export { render, staticRenderFns }